var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { ref: "footerH", staticClass: "footer" },
    [
      _vm.brandKey === "rwc"
        ? _c("div", { staticClass: "branded-footer" }, [
            _c("div", { staticClass: "branded-footercontent" }, [
              _c("div", { staticClass: "bf-left" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/brands/rwc/RWC_Logo_Casino-Resort-RGB-KO.png")
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "line" }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "text",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("Footer.playResponsiblyDesc"))
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "bf-right" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/brands/rwc/Playtime-Elevated-Building.png")
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contact-us" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "info",
                            params: { infopagename: "contact" }
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Footer.ContactUs")))]
                    )
                  ],
                  1
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      [
        _c("div", { staticClass: "footer-top footercontent" }, [
          _c("div", { staticClass: "footer-top-left" }, [
            _c("section", { staticClass: "company-pr" }, [
              _c(
                "div",
                { staticClass: "link" },
                [
                  _c("img", {
                    attrs: { src: "/static/images/footer/gamble-banner.png" }
                  }),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: "info",
                          params: { infopagename: "responsible-gaming" }
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Footer.FindOutMore")))]
                  )
                ],
                1
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "footer-ocean-state" }, [
          _c("section", { staticClass: "footercontent" }, [
            _c("div", { staticClass: "col-right" }, [
              _vm._v(_vm._s(_vm.$t("Footer.oceanState")))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "bottom-info" }, [
          _c(
            "section",
            { staticClass: "footer-menu" },
            [
              _c("site-navigation", {
                attrs: { "navigation-section": "FOOTER_MENU_RWC" }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "footer-bottom" }, [
          _c("div", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.$t("Footer.info.companyName")))
          ]),
          _vm._v(" "),
          _c(
            "section",
            {
              staticClass: "back-to-top",
              class: {
                "ios-back-to-top":
                  _vm.userAgent === "ios" && _vm.appVersion === "safari"
              }
            },
            [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.goBack()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("expand_less")])],
                1
              )
            ]
          )
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-503caf7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-503caf7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/parts/FooterPart.vue
// module id = null
// module chunks = 